export default __webpack_public_path__ + "static/media/FACEBOOK_icon.ae84b136.svg";